const ASSETS_BASE_PATH = 'assets/images';

export const IMAGES = {
    LOGOS: {
        SHIJI_LOGO_BLUE0_SVG: ASSETS_BASE_PATH + '/ShijiLogoBlue0.svg',
        ICEPORTAL_CONTENT_LOGO_VERTICAL_SVG: ASSETS_BASE_PATH + '/iceportalContentLogoVertical.svg',
        ICEPORTAL_CONTENT_LOGO_HORIZONTAL_SVG: ASSETS_BASE_PATH + '/iceportalContentLogoHorizontal.svg',
        ICE_LOGO_WHITE_PNG: ASSETS_BASE_PATH + '/ice-logo-white.png',
        DAL_LOGO_WHITE_PNG: ASSETS_BASE_PATH + '/dal-logo-white.png',
    },
    LOGIN_HERO_2_JPG: ASSETS_BASE_PATH + '/loginHero2.jpg',
    IMAGE_PLACEHOLDER_JPG: ASSETS_BASE_PATH + '/imagePlaceholder.jpg',
    TRANSPARENT_GIF: ASSETS_BASE_PATH + '/transparent.gif',
};
